$ = require 'jquery'
Action = require 'models/action'
ActionTemplate = require 'views/templates/action-react'
Auth = require 'db/auth'
BoardListSectionHeaderComponent = require 'views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'views/board-list/board-list-section-header-link-component'
BoardsPageActivityFeedInfoView = require 'views/member/boards-page-activity-feed-info-view'
BoardsPageActivityFeedFilterView = require 'views/member/boards-page-activity-feed-filter-view'
f = require 'effing'
l = require 'lib/localize'
Label = require 'models/label'
memberAvatarTemplate = require 'views/templates/member_avatar'
moment = require 'moment'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')()
track = require 'debug/track'
Util = require 'lib/util'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'

module.exports = class ActivityFeedComponent extends React.Component
  displayName: 'ActivityFeedComponent'
  maxPageResults: 50

  constructor: (props) ->
    super props

    @state = {
      shouldShowPopOver: !Auth.me().isDismissed('activityFeedExperimentInfoPopover')
    }

    @showInitialPopOver = @showInitialPopOver.bind(@)
    @showInfoPopOver = @showInfoPopOver.bind(@)
    @trackOnClickInfoButton = @trackOnClickInfoButton.bind(@)
    @toggleFilterPopOver = @toggleFilterPopOver.bind(@)
    @filterActivityFeed = @filterActivityFeed.bind(@)
    @filterOnClick = @filterOnClick.bind(@)
    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@)

  # doing this for both componentDidMount and componentDidUpdate becuase actions usually aren't there when componentDidMount
  componentDidMount: ->
    @showInitialPopOver(@props)

  componentDidUpdate: ->
    @showInitialPopOver(@props)

  # if popover hasn't been dismissed and there are acitons then show popover
  showInitialPopOver: (props) ->
    if @state.shouldShowPopOver && props.actions.length
      @showInfoPopOver()

      @setState
        shouldShowPopOver: false
      Auth.me().dismiss('activityFeedExperimentInfoPopover')

  showInfoPopOver: ->
    PopOver.toggle
      elem: $('.js-activity-feed-info')
      view: new BoardsPageActivityFeedInfoView({ memberId: Auth.me().get('id') })

  trackOnClickInfoButton: (e) ->
    Util.preventDefault(e)
    @showInfoPopOver()
    track('Boards View', 'Activity Feed', 'Clicked info button')
    return

  toggleFilterPopOver: ->
    PopOver.toggle
      elem: $('.js-activity-feed-filter')
      view: new BoardsPageActivityFeedFilterView({
        filterActivityFeed: @filterActivityFeed,
        organizationList: @props.organizationList,
        currentFilter: @props.filterBy
      })

  filterActivityFeed: (filterVal) ->
    @toggleFilterPopOver()
    @props.filterActivityFeed(filterVal)

  filterOnClick: (e) ->
    Util.preventDefault(e)
    @toggleFilterPopOver()
    track('Boards View', 'Activity Feed', 'Clicked filter dropdown')

  trackOnClickCanonicalCard: ->
    track('Boards View', 'Activity Feed', 'Clicked on card')

  render: t.renderable ->
    { actions
      filterBy
      loadingMore
      loadingNew
      loadMoreActivities
      moreActivitiesLength
      organizationList
      showUnreadActions
      unreadActions
    } = @props

    t.div '.boards-page-board-activity-feed.boards-page-board-section.mod-no-sidebar', =>

      linkElements = [
          {
            url: '#',
            iconClass: 'information',
            linkClasses:
              'js-activity-feed-info': true,
              'activity-feed-info': true
            titleKey: 'info',
            onClick: @trackOnClickInfoButton
          }
        ]

      if organizationList.length
        filterDisplay = switch filterBy
          when '' then 'All'
          when 'personal' then 'Personal'
          else organizationList.find((org) => org.id == filterBy).get('displayName')

        linkElements.push {
          url: '#',
          iconClass: 'down',
          linkClasses:
            'js-activity-feed-filter': true
            'activity-feed-filter': true
          titleKey: 'filter',
          titleText: filterDisplay,
          onClick: @filterOnClick
        }

      if unreadActions.length
        linkElements.push {
            url: '#',
            iconClass: 'refresh',
            linkClasses:
              'load-new-activity': true
            titleKey: 'load-new-activity',
            onClick: showUnreadActions
          }

      t.addElement React.createElement BoardListSectionHeaderComponent, {
        title: l('board section title.activity feed')
        iconClass: 'activity'
        linkElements: linkElements.map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))
      }

      if loadingNew
        t.div ->
          t.div '.spinner.loading'

      else if actions.length
        actions.map (action) =>
          card = action.card
          board = card.getBoard()
          canReply =
            board?.canComment(Auth.me()) &&
            (
              action.isAddAttachment ||
              (action.isCommentLike && action.memberCreator? && !Auth.isMe(action.memberCreator))
            )

          t.div '.boards-page-board-activity', { 'key': action.id }, =>
            t.div '.boards-page-board-activity-card', { onClick: =>
              @trackOnClickCanonicalCard()
            } , ->
              t.tag CanonicalCard, {
                board
                canRemove: false
                card
                labels: card.getLabels().sort(Label.compare)
                list: card.getList()
                members: card.memberList.models
                numNotifications: 0
              }
            t.div '.boards-page-board-activity-comment', ->
              cardUrl = action.card.get('url')
              timestampUrl = "#{cardUrl}#comment-#{action.id}"

              replyUrl = cardUrl
              if action.memberCreator?.username
                replyUrl += "?replyToComment=#{action.memberCreator.username}"

              actionData =
                entities: [action.entity]
                saved: true
                date: action.entity.date
                url: timestampUrl

              context =
                member: action.memberCreator
                canReply: canReply
                showMemberFullName: true
                replyUrl: replyUrl

              options =
                useEmbedly: false
                usePreviews: false
                showOptions: true
                fullWidthComment: true
                noPhenomPadding: true
                trackReply: -> track('Boards View', 'Activity Feed', 'Clicked reply')
                trackTimestamp: -> track('Boards View', 'Activity Feed', 'Clicked timestamp')

              t.tag ActionTemplate, {
                actionData: actionData
                context: context
                options: options
              }

        if loadingMore
          t.div ->
            t.div '.spinner.loading'

        else
          if actions.length == @maxPageResults || moreActivitiesLength == @maxPageResults
            t.a '.show-more.u-text-align-center', { onClick: loadMoreActivities, href: '#' }, ->
              t.text 'Show More Activities'

      else
        t.div ->
          t.p '.empty', ->
            t.text 'No Activity'



// WEBPACK FOOTER //
// ./app/scripts/views/member/activity-feed-component.coffee